<template>
  <div>
    <div class="admin ">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">Mensajes</h1>
                </div>
              </div>
            </div>

            <!-- lista de mensajes -->
            <div class="row mt-0 mb-5">
              <div class="col-12">
                <div>
                  <div
                    class="top d-flex align-items-center justify-content-between mb-3"
                  >
                    <h2 class="font-weight-black">
                      Lista de mensajes de la pagina
                    </h2>
                  </div>

                  <!-- loader -->
                  <div v-if="loader" class="text-center loader-wrap-min">
                    <div
                      class="spinner-border text-primary"
                      style="width: 75px; height: 75px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <!-- /loader -->

                  <div v-if="!loader">
                    <v-card
                      class="mb-5 mx-auto"
                      outlined
                      v-for="(item, index) in mensajes"
                      :key="item.id"
                    >
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="overline mb-4">
                            {{ item.nombre }} {{ item.email }} |
                            {{ item.telefono }} <br />
                            {{ item.fecha }}
                          </div>
                          <v-list-item-title class="headline mb-1">{{
                            item.asunto
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            item.mensaje
                          }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-icon color="primary">messages</v-icon>
                      </v-list-item>

                      <v-card-actions> </v-card-actions>
                    </v-card>

                    <!-- vacio -->
                    <div v-if="mensajes == ''">
                      <div class="vacio">
                        <span>No hemos encontrado mensajes</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /lista de mensajes  -->
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      mensajes: [],
      loader: true,
    };
  },
  methods: {
    getMensajes() {
      //Obtenemos los mensajes de la pagina
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/pagina/pagina__controller.php?ot=getMensajes"
        )
        .then((response) => {
          this.loader = false;
          this.mensajes = response.data;
        })
        .catch((error) => console.log(error));
    },
  },
  computed: {
    ...mapState(["buscarProductoCategoria", "buscarProductoTermino"]),
  },
  mounted() {
    this.getMensajes();
  },
};
</script>
